import _styled21 from "../web_modules/styled-components.js";
import _styled20 from "../web_modules/styled-components.js";
import _styled19 from "../web_modules/styled-components.js";
import _styled18 from "../web_modules/styled-components.js";
import _styled17 from "../web_modules/styled-components.js";
import _styled16 from "../web_modules/styled-components.js";
import _styled15 from "../web_modules/styled-components.js";
import _styled14 from "../web_modules/styled-components.js";
import _styled13 from "../web_modules/styled-components.js";
import _styled12 from "../web_modules/styled-components.js";
import _styled11 from "../web_modules/styled-components.js";
import _styled10 from "../web_modules/styled-components.js";
import _styled9 from "../web_modules/styled-components.js";
import _styled8 from "../web_modules/styled-components.js";
import _styled7 from "../web_modules/styled-components.js";
import _styled6 from "../web_modules/styled-components.js";
import _styled5 from "../web_modules/styled-components.js";
import _styled4 from "../web_modules/styled-components.js";
import _styled3 from "../web_modules/styled-components.js";
import _styled2 from "../web_modules/styled-components.js";
import _styled from "../web_modules/styled-components.js";
import React from "../web_modules/react.js"; // @ts-expect-error: TODO: Type this

import serialize from "../web_modules/for-cerial.js";
import "../web_modules/@reach/dialog/styles.css";
import { LoadingButton } from "../web_modules/@ticketbutler/toolbox.js";
import "../web_modules/@ticketbutler/toolbox/dist/style.css";
import "../web_modules/@reach/menu-button/styles.css";
import { useAsyncStatus, AsyncStates } from "../web_modules/use-async-status.js";
import CountryDialingCodeSelect from "./country_dialing_code_select.js";
import "./index.css";
import { useLanguage, API_HOST, makeTbRequestHeaders, styles, FieldErrors, getFieldError, getThemedButton } from "./app.js";
import { useScrollToError } from "./shared.js";
import { useTranslation } from "../web_modules/react-i18next.js";
import Select from "../web_modules/react-select.js";

var _StyledDiv = _styled("div").withConfig({
  displayName: "waiting_list___StyledDiv",
  componentId: "sc-1ik7gzg-0"
})({
  marginTop: "5%"
});

var _StyledH = _styled("h1").withConfig({
  displayName: "waiting_list___StyledH",
  componentId: "sc-1ik7gzg-1"
})({
  textAlign: "center",
  fontSize: 20,
  fontWeight: "bold"
});

var _StyledHr = _styled("hr").withConfig({
  displayName: "waiting_list___StyledHr",
  componentId: "sc-1ik7gzg-2"
})({
  margin: "25px 0"
});

var _StyledP = _styled("p").withConfig({
  displayName: "waiting_list___StyledP",
  componentId: "sc-1ik7gzg-3"
})({
  marginBottom: 30,
  textAlign: "center"
});

var _StyledP2 = _styled("p").withConfig({
  displayName: "waiting_list___StyledP2",
  componentId: "sc-1ik7gzg-4"
})({
  textAlign: "center"
});

var _StyledForm = _styled("form").withConfig({
  displayName: "waiting_list___StyledForm",
  componentId: "sc-1ik7gzg-5"
})(["", ""], p => p._css);

var _StyledP3 = _styled("p").withConfig({
  displayName: "waiting_list___StyledP3",
  componentId: "sc-1ik7gzg-6"
})(["", ""], p => p._css2);

var _StyledLabel = _styled("label").withConfig({
  displayName: "waiting_list___StyledLabel",
  componentId: "sc-1ik7gzg-7"
})(["", ""], p => p._css3);

var _StyledInput = _styled("input").withConfig({
  displayName: "waiting_list___StyledInput",
  componentId: "sc-1ik7gzg-8"
})(["", ""], p => p._css4);

var _StyledLabel2 = _styled("label").withConfig({
  displayName: "waiting_list___StyledLabel2",
  componentId: "sc-1ik7gzg-9"
})(["", ""], p => p._css5);

var _StyledInput2 = _styled("input").withConfig({
  displayName: "waiting_list___StyledInput2",
  componentId: "sc-1ik7gzg-10"
})(["", ""], p => p._css6);

var _StyledLabel3 = _styled("label").withConfig({
  displayName: "waiting_list___StyledLabel3",
  componentId: "sc-1ik7gzg-11"
})(["", ""], p => p._css7);

var _StyledInput3 = _styled("input").withConfig({
  displayName: "waiting_list___StyledInput3",
  componentId: "sc-1ik7gzg-12"
})(["", ""], p => p._css8);

var _StyledLabel4 = _styled("label").withConfig({
  displayName: "waiting_list___StyledLabel4",
  componentId: "sc-1ik7gzg-13"
})(["", ""], p => p._css9);

var _StyledInput4 = _styled("input").withConfig({
  displayName: "waiting_list___StyledInput4",
  componentId: "sc-1ik7gzg-14"
})(["", ""], p => p._css10);

var _StyledLabel5 = _styled("label").withConfig({
  displayName: "waiting_list___StyledLabel5",
  componentId: "sc-1ik7gzg-15"
})(["", ""], p => p._css11);

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "waiting_list___StyledDiv2",
  componentId: "sc-1ik7gzg-16"
})({
  display: "flex",
  flexWrap: "wrap"
});

var _StyledInput5 = _styled("input").withConfig({
  displayName: "waiting_list___StyledInput5",
  componentId: "sc-1ik7gzg-17"
})(["", ""], p => p._css12);

var _StyledLabel6 = _styled("label").withConfig({
  displayName: "waiting_list___StyledLabel6",
  componentId: "sc-1ik7gzg-18"
})(["", ""], p => p._css13);

var _StyledButton = _styled("button").withConfig({
  displayName: "waiting_list___StyledButton",
  componentId: "sc-1ik7gzg-19"
})(["", ""], p => p._css14);

var _StyledP4 = _styled("p").withConfig({
  displayName: "waiting_list___StyledP4",
  componentId: "sc-1ik7gzg-20"
})({
  color: "red",
  textAlign: "center"
});

export function WaitingList({
  theme,
  event
}) {
  const language = useLanguage();
  const {
    t
  } = useTranslation();
  const options = Array.from({
    length: event.eventsettings.ticket_limit
  }).map((_, i) => {
    return {
      label: i + 1,
      value: i + 1
    };
  });
  const buttonCheckMark = /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 34,
      lineHeight: 0.5
    }
  }, "\u2714");
  const [waitingListSuccess, setWaitingListSuccess] = React.useState(false);
  const {
    trigger: enrollWaitingList,
    status,
    lastError
  } = useAsyncStatus(async function enrollWaitingList(values) {
    const req = await fetch([API_HOST, "waiting-list/enroll-to-waiting-list/"].join("/"), {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify({
        event_uuid: event.uuid,
        ...values
      })
    });

    if (req.ok) {
      setWaitingListSuccess(true);
    } else {
      const errors = await req.json();
      throw errors;
    }
  });
  useScrollToError(Boolean(lastError));
  return waitingListSuccess ? /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledH, null, t("event.subscribed").toUpperCase(), "!")), /*#__PURE__*/React.createElement(_StyledHr, null), /*#__PURE__*/React.createElement(_StyledP, null, t("event.subscribingToTicketNotifications")), /*#__PURE__*/React.createElement(_StyledP2, null, event.is_free_event ? t("event.emailAboutAvailableSpots") : t("event.emailAboutAvailableTickets"))) : /*#__PURE__*/React.createElement(_StyledForm, {
    onSubmit: function (e) {
      e.preventDefault();
      const values = serialize(e.target, {
        hash: true,
        empty: true
      });
      enrollWaitingList(values);
    },
    _css: [{
      display: "flex",
      flexDirection: "column",
      margin: "15px auto 35px auto !important"
    }, styles.form]
  }, /*#__PURE__*/React.createElement(_StyledP3, {
    _css2: styles.checkoutModalHeading
  }, t("event.signUpToTicketNotifications")), /*#__PURE__*/React.createElement(_StyledLabel, {
    _css3: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.firstName"), " *"), /*#__PURE__*/React.createElement(_StyledInput, {
    name: "first_name",
    required: true,
    _css4: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "first_name")
  })), /*#__PURE__*/React.createElement(_StyledLabel2, {
    _css5: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.lastName"), " *"), /*#__PURE__*/React.createElement(_StyledInput2, {
    name: "last_name",
    required: true,
    _css6: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "last_name")
  })), /*#__PURE__*/React.createElement(_StyledLabel3, {
    _css7: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, "Email *"), /*#__PURE__*/React.createElement(_StyledInput3, {
    type: "email",
    name: "email",
    required: true,
    _css8: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "email")
  })), /*#__PURE__*/React.createElement(_StyledLabel4, {
    _css9: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.repeat"), " Email *"), /*#__PURE__*/React.createElement(_StyledInput4, {
    type: "email",
    name: "email_2",
    required: true,
    _css10: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "email_2")
  })), /*#__PURE__*/React.createElement(_StyledLabel5, {
    _css11: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.phone"), " *"), /*#__PURE__*/React.createElement(_StyledDiv2, null, /*#__PURE__*/React.createElement(CountryDialingCodeSelect, null), /*#__PURE__*/React.createElement(_StyledInput5, {
    required: true,
    name: "phone",
    type: "tel",
    "data-testid": "phoneLong",
    _css12: [styles.input, {
      flexGrow: 1,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    }]
  })), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "phone")
  })), /*#__PURE__*/React.createElement(_StyledLabel6, {
    _css13: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.numberOfTickets"), " *"), /*#__PURE__*/React.createElement(Select, {
    required: true,
    isSearchable: false,
    styles: {
      control: defaultStyle => ({ ...defaultStyle,
        height: 41
      })
    },
    name: "tickets_number",
    defaultValue: options[0],
    options: options
  })), /*#__PURE__*/React.createElement(LoadingButton, {
    loading: status === AsyncStates.Pending,
    success: status === AsyncStates.Success,
    successMessage: buttonCheckMark
  }, /*#__PURE__*/React.createElement(_StyledButton, {
    type: "submit",
    _css14: [getThemedButton(theme), {
      margin: "0 auto",
      marginTop: 15
    }]
  }, t("event.signUp"))), /*#__PURE__*/React.createElement(React.Fragment, null, lastError instanceof Error && /*#__PURE__*/React.createElement(_StyledP4, {
    className: "errorMessage"
  }, t("event.errorTryAgain"), ".")));
}